import { render, staticRenderFns } from "./DescuentosEmpleadosFC.vue?vue&type=template&id=2de76836&scoped=true&"
import script from "./DescuentosEmpleadosFC.vue?vue&type=script&lang=js&"
export * from "./DescuentosEmpleadosFC.vue?vue&type=script&lang=js&"
import style0 from "./DescuentosEmpleadosFC.vue?vue&type=style&index=0&id=2de76836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de76836",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
